<template>
  <button type="button" class="btn btn-block btn-add">
    <slot></slot>
    <i class="icon icon-add"></i>
  </button>
</template>
